export enum AlertLevel {
  SUCCESS = "alert-success",
  INFO = "alert-info",
  WARNING = "alert-warning",
  DANGER = "alert-danger",
}
